"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUILDER_MANIFEST = exports.SCENE_MANIFEST = exports.EMOTE_MANIFEST = exports.WEARABLE_MANIFEST = exports.MAX_SKIN_FILE_SIZE = exports.MAX_EMOTE_FILE_SIZE = exports.MAX_WEARABLE_FILE_SIZE = exports.MAX_THUMBNAIL_FILE_SIZE = exports.MAX_FILE_SIZE = void 0;
/** @deprecated please use MAX_THUMBNAILS_FILE_SIZE | MAX_WEARABLE_FILE_SIZE | MAX_SKIN_FILE_SIZE | MAX_EMOTE_FILE_SIZE instead */
exports.MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB
exports.MAX_THUMBNAIL_FILE_SIZE = 1024 * 1024; // 1MB
exports.MAX_WEARABLE_FILE_SIZE = 2 * 1024 * 1024; // 2MB
exports.MAX_EMOTE_FILE_SIZE = 2 * 1024 * 1024; // 2MB
exports.MAX_SKIN_FILE_SIZE = 8 * 1024 * 1024; // 8MB
exports.WEARABLE_MANIFEST = 'wearable.json';
exports.EMOTE_MANIFEST = 'emote.json';
exports.SCENE_MANIFEST = 'scene.json';
exports.BUILDER_MANIFEST = 'builder.json';
//# sourceMappingURL=constants.js.map